///<reference path='../../../mobile/core/directives/AutocompleterField.ts'/>
'use strict';
namespace Autocompleter {

    type ArrayUtil = Core.ArrayUtil;

    class ManySelect {

        model: any[];
        options: any[];
        remainingOptions: any[];

        private prefix: string;

        constructor (
            public $scope: any,
            public $route: ng.route.IRouteService,
            public autocompleter: any,
            public resourceService: any,
            public $q: ng.IQService,
            public $timeout: ng.ITimeoutService,
            public arrayUtil: ArrayUtil
        ) {
            $timeout(() => {
                $scope.$watch(
                    () => ({ options: this.options, model: this.model, prefix: this.prefix }),
                    val => {
                        this.remainingOptions = this.arrayUtil.difference<any>(val.options, val.model);
                        const prefix = val.prefix && val.prefix.toLowerCase();
                        if (prefix) {
                            this.remainingOptions = _.filter(this.remainingOptions,
                                o => o.Title && o.Title.toLowerCase().indexOf(prefix) > -1);
                        }
                    },
                    true
                );
            });
        }

        select (item: any): void {
            if (item && this.model) {
                const isAlreadySelected = _.some(this.model, o => angular.equals(item, o));
                if (!isAlreadySelected) {
                    this.model.push(item);
                }
                this.prefix = '';
            }
        }

        removeItem (item: any): void {
            if (item) {
                this.model.splice(this.model.indexOf(item), 1);
            }
        }

        blur () {
            this.$timeout(() => {
                if (this.prefix) {
                    var firstItem = _.find(this.remainingOptions, d => !d.header);
                    if (firstItem) {
                        this.select(firstItem);
                    }
                }
            }, 200);
        }
    }

    angular
        .module('TR')
        .directive('manySelect', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                controllerAs: 'ms',
                bindToController: {
                    placeholder: '@',
                    model: '=',
                    options: '=',
                    iconClass: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=ManySelect',
                controller: ManySelect,
                transclude: true,
                link: (
                    scope: any,
                    el: JQuery
                ) => {
                    scope.ms.inputField = el.find('input');
                }
            };
        });
}
